import type { IconProps } from './types/types';
import IconWrapper from './wrapper/SvgIconWrapper';

const RoundedSquareOutlined = (props: IconProps) => {
  return (
    <IconWrapper {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5 4.5H4.5V11.5H11.5V4.5ZM4.5 2.5C3.39543 2.5 2.5 3.39543 2.5 4.5V11.5C2.5 12.6046 3.39543 13.5 4.5 13.5H11.5C12.6046 13.5 13.5 12.6046 13.5 11.5V4.5C13.5 3.39543 12.6046 2.5 11.5 2.5H4.5Z"
          fill={props.color}
        />
      </svg>
    </IconWrapper>
  );
};

export default RoundedSquareOutlined;
